
export default {
    data() {
        return {
            loading: false,
            success: false,
            server_error: null,
        }
    },
    methods: {
        handleError(e) {
            this.loading = false
            this.success = false
            this.server_error = e
        },
        handleSuccess(type) {
            this.server_error = null
            this.loading = false
            this.success = true

            this.$toasted.global.info({
                title: this.$t(`toasts.success_${type}`),
                description: this.$t(`toasts.success_${type}_desc`),
            });
            setTimeout(() => {
                this.success = false
            }, 5000);
        }
    }
}
